import {
  ProjectFormatter,
  AmountFormatter,
  UserFormatter,
  TaskFormatter,
  StringFormatter,
  DateRangeFormatter,
  AdhocDescriptionFormatter,
  ExpenseCodeFormatter,
  BillingRateFormatter
} from '~/modules/billing-invoicing/common/columnFormatters';
import { Money as MoneyFormatter } from '~/modules/common/components/ListTable/renderers';
import DeleteLineItem from './DeleteLineItem';
import { QuantityFormatter } from './QuantityFormatter';
import QuantityRenderer from './QuantityRenderer';
import DescriptionRenderer from './DescriptionRenderer';
import RateRenderer from './RateRenderer';
import AmountRenderer from './AmountRenderer';

const getFormatters = (editable, hasAdhocLineItems) => ({
  deleteIcon: DeleteLineItem,
  project: ProjectFormatter,
  amount: hasAdhocLineItems
    ? AmountRenderer
    : !editable
    ? MoneyFormatter
    : AmountFormatter,
  lineItemsTotal: MoneyFormatter,
  task: TaskFormatter,
  user: UserFormatter,
  billingType: StringFormatter,
  billingContractScriptName: StringFormatter,
  quantity: hasAdhocLineItems ? QuantityRenderer : QuantityFormatter,
  rate: hasAdhocLineItems ? RateRenderer : MoneyFormatter,
  description: hasAdhocLineItems
    ? DescriptionRenderer
    : AdhocDescriptionFormatter,
  timesheetPeriod: DateRangeFormatter,
  payCode: StringFormatter,
  role: StringFormatter,
  expenseCode: ExpenseCodeFormatter,
  billingRate: BillingRateFormatter
});

export default getFormatters;
